// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3uPKk","text":"SelectPayment_text__22ye5","title":"SelectPayment_title__2oFLf","btn":"SelectPayment_btn__1O8M6"};